import * as React from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import { isAuthenticated } from 'utils/auth';
import AttendanceList from './containers/AttendanceList/AttendanceList';
import Confirmation from './containers/Confirmation/Confirmation';
import Login from './containers/Login/Login';
import SessionList from './containers/SessionList/SessionList';

/* eslint-disable react/jsx-props-no-spreading */
const ProtectedRoute = ({ children, component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        children || React.createElement(component, props)
      ) : (
        <Redirect
          to={{
            pathname: '/login',
          }}
        />
      )
    }
  />
);
/* eslint-enable react/jsx-props-no-spreading */

const Routes = () => {
  return (
    <Router>
      <Switch>
        <Route path="/login" exact component={Login} />
        <ProtectedRoute
          path={['/', '/sessions']}
          exact
          component={SessionList}
        />
        <ProtectedRoute path="/sessions/:id" exact component={AttendanceList} />
        <ProtectedRoute path="/sessions/:id/confirm" component={Confirmation} />
      </Switch>
    </Router>
  );
};

export default Routes;
